export const toSLug = (string: string): string => string.toLowerCase().replace(/ /g, "-");
